import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGetUserQuery } from 'shared/api/auth/requests'
import { useHistory, useUserContext } from 'shared/hooks'
import { useCommonStore } from 'shared/stores/commonStore'

import { FullPageAppTemplate } from '../../templates'
import styles from './WorkflowsApp.module.scss'

const WorkflowsApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const isInternalUser = useCommonStore(state => state.isInternalUser)
  const { apps } = useAvailableApps()

  const { data: userData } = useGetUserQuery(
    {
      id: user?.id || -1
    },
    {
      enabled: typeof user?.id === 'number'
    }
  )

  return (
    <FullPageAppTemplate
      appId={AppId.WORKFLOWS}
      scope='workflows'
      envKey={apps[AppId.WORKFLOWS].runtimeEnvKey}
      entryPath='./WorkflowsApp'
      url={process.env.REACT_APP_WORKFLOWS_APP_DEV_PATH}
      appName={apps[AppId.WORKFLOWS].name}
      className={styles.wrapper}
      appProps={{
        user,
        extendedUser: userData?.data,
        initialPath: location.pathname,
        defaultHistory: history,
        history: history,
        appPath: apps[AppId.WORKFLOWS].path,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        },
        isInternalUser: isInternalUser([], true)
      }}
    />
  )
}

export { WorkflowsApp }
